import React from 'react';
import { useTranslation } from 'react-i18next';

import CollapseIcon from '~/assets/CollapseIcon';
import PenIcon from '~/assets/PenIcon';

import { EditTitleButton, ExpandButton, ExpandedHeader, ExpandedTitle, TitleGroup } from './AIInsightsSidebar.styles';

interface AIInsightsSidebarExpandedHeaderProps {
  title: string;
  onCollapse: () => void;
  onEditName?: () => void;
}

const AIInsightsSidebarExpandedHeader = ({ title, onCollapse, onEditName }: AIInsightsSidebarExpandedHeaderProps) => {
  const { t } = useTranslation();

  return (
    <ExpandedHeader>
      <TitleGroup>
        <ExpandedTitle title={title}>{title}</ExpandedTitle>
        {onEditName && (
          <EditTitleButton onClick={onEditName} aria-label={t('aiInsights.editConversationName')}>
            <PenIcon />
          </EditTitleButton>
        )}
      </TitleGroup>
      <ExpandButton onClick={onCollapse} aria-label={t('aiInsights.collapse')}>
        <CollapseIcon />
      </ExpandButton>
    </ExpandedHeader>
  );
};

export default AIInsightsSidebarExpandedHeader;
